var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-wrapper',[_c('back-nav',{attrs:{"back":_vm.$t('back.back'),"title":_vm.$t('detail.title')}}),_c('detailoverview-nav',{attrs:{"onchaindata":_vm.onchaindata,"offchaindata":_vm.offchaindata}}),_c('detailtable-nav',{attrs:{"address":_vm.onchaindata.address,"pk":_vm.onchaindata.public_key}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }